
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { RequestsTable } from "./RequestsTable";

interface RequestItem {
  id: string;
  merchant: string;
  amount: string;
  status: string;
  date: string;
}

interface DashboardTabsProps {
  activeRequests: RequestItem[];
  completedRequests: RequestItem[];
}

export function DashboardTabs({ activeRequests, completedRequests }: DashboardTabsProps) {
  return (
    <div className="bg-white rounded-lg border shadow-sm p-6 animate-fade-in">
      <Tabs defaultValue="active" className="w-full">
        <div className="mb-6">
          <TabsList className="grid w-full max-w-md grid-cols-2">
            <TabsTrigger value="active">
              Active Requests
            </TabsTrigger>
            <TabsTrigger value="completed">
              Completed
            </TabsTrigger>
          </TabsList>
        </div>
        
        <TabsContent value="active" className="mt-2">
          <RequestsTable 
            requests={activeRequests} 
            emptyMessage="No active requests found."
            createNewLabel="Create New Request"
          />
        </TabsContent>
        <TabsContent value="completed" className="mt-2">
          <RequestsTable 
            requests={completedRequests} 
            emptyMessage="No completed requests found."
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
